import React from "react";

import useAdminTopbar from "./adminShell/hooks/useAdminTopbar";
import TopBarIdentity from "./adminShell/components/TopBarIdentity";
import TopBarActions from "./adminShell/components/TopBarActions";

export default function TopBarAdmin() {
  const {
    user,
    mounted,
    theme,
    pageMeta,
    ville,
    logoSrc,
    avatarSrc,
    isLogged,
    unreadContactCount,
    handleLogout,
    toggleTheme,
    goToPublicSite,
    goToProfile,
    goToDashboard,
    goToContactMessages,
  } = useAdminTopbar();

  return (
    <header className="fixed inset-x-0 top-0 z-[60] h-[88px] border-b border-slate-200/80 bg-white/90 shadow-sm backdrop-blur-xl dark:border-slate-800/80 dark:bg-slate-950/90">
      <div className="mx-auto flex h-full max-w-[1920px] items-center justify-between gap-3 px-4 sm:px-5 lg:px-6">
        <TopBarIdentity
          logoSrc={logoSrc}
          ville={ville}
          pageMeta={pageMeta}
          onGoToDashboard={goToDashboard}
        />

        <TopBarActions
          user={user}
          avatarSrc={avatarSrc}
          isLogged={isLogged}
          mounted={mounted}
          theme={theme}
          unreadContactCount={unreadContactCount}
          onGoToContactMessages={goToContactMessages}
          onGoToDashboard={goToDashboard}
          onGoToPublicSite={goToPublicSite}
          onToggleTheme={toggleTheme}
          onLogout={handleLogout}
        />
      </div>
    </header>
  );
}
